(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  $(document).ready( ()=>{

    let navicons = document.querySelectorAll('.nav-icon');

    for(var i = 0; i < navicons.length; i++) {
      navicons[i].addEventListener('mouseenter', (e)=>{
        let hovered = e.target.getElementsByClassName('hovered');
        let unhovered = e.target.getElementsByClassName('unhovered');
        if (hovered && hovered[0]) {
          hovered[0].style.display="block";
        }
        if (unhovered && unhovered[0]) {
          unhovered[0].style.display="none";
        }

        if (e.target.parentNode.classList.contains("lang-switcher")) {
          console.log(e.target.parentNode.classList)
          $('#desktop-lang-switcher select').css('color', '#4ea7b3');
        }
        
      })

      navicons[i].addEventListener('mouseleave', (e)=>{
        let hovered = e.target.getElementsByClassName('hovered');
        let unhovered = e.target.getElementsByClassName('unhovered');
        if (hovered && hovered[0]) {
          hovered[0].style.display="none";
        }
        if (unhovered && unhovered[0]) {
          unhovered[0].style.display="block";
        }
      })
    }
  })




  } catch(e) { console.error(e); }
})();
})();
